import React, { Fragment, useEffect, useState } from "react";
import { ArrowLeft, ArrowRight } from "react-feather";
import SidebarMenuItems from "./SidebarMenuItems";
import ConfigDB from "../../Config/Theme-Config";

const SidebarMenu = ({
  props,
  sidebartoogle,
  width,
}) => {
  const [rightArrow, setRightArrow] = useState(false);
  const [leftArrow, setLeftArrow] = useState(false);
  const sidebar_types = localStorage.getItem("sidebar_types");
  const wrapper = sidebar_types || ConfigDB.settings.sidebar.type;
  const [margin, setMargin] = useState(0);
  useEffect(() => {
    setLeftArrow(true);
  }, []);
  const scrollToRight = () => {
    if (margin <= -2598 || margin <= -2034) {
      setMargin(width === 492 ? -3570 : -3464);
      setRightArrow(true);
    } else {
      setMargin((prev) => prev - width);
      setLeftArrow(false); // Ensure left arrow is visible when scrolling right
    }
  };

  const scrollToLeft = () => {
    if (margin >= -width) {
      setMargin(0);
      setLeftArrow(true);
      setRightArrow(false);
    } else {
      setMargin((prev) => prev + width);
      setRightArrow(false);
    }
  };

  return (
    <Fragment>
      <nav className="sidebar-main" style={{ flex: "1" }}>
        <div
          className={`left-arrow ${leftArrow ? "d-none" : ""}`}
          onClick={scrollToLeft}
        >
          <ArrowLeft />
        </div>
        <div
          id="sidebar-menu"
          style={{
            height: "100%",
            ...(wrapper.split(" ").includes("horizontal-wrapper")
              ? { marginLeft: margin + "px" }
              : { margin: "0px" }),
          }}
        >
          <SidebarMenuItems
            props={props}
            sidebartoogle={sidebartoogle}
          />
        </div>
        <div
          className={`right-arrow ${rightArrow ? "d-none" : ""}`}
          onClick={scrollToRight}
        >
          <ArrowRight />
        </div>
      </nav>
    </Fragment>
  );
};

export default SidebarMenu;
